module.exports = __webpack_public_path__ + "media/images/flags/32/Oman-493d7aa8bc1d2e918cc71167c326398d.png";